<div class="sentiment-analysis">
  <app-sentiment-analysis-settings-home
    [canWrite]="sentimentSettingsCanWrite"
    [brandIdForApi]="brandIdForApi"
    [brandDetails]="brandDetailsForSetup"
    (settingsSaved)="onSentimentSettingsSaved($event)"
    (configurationSaved)="onSentimentConfigurationSaved($event)"
    (settingsMessage)="showSnackbar($event.text, $event.kind)"
  />

  <ng-container *ngIf="loading">
    <div class="sentiment-analysis__loading">
      <app-ltms-loader></app-ltms-loader>
      <p class="sentiment-analysis__loading-text">
        {{
          configGate === 'checking'
            ? config.copy.checkingConfig
            : config.copy.loadingStats
        }}
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading && brandIdForApi && configGate === 'setup_required'">
    <app-sentiment-analysis-getting-started
      [brandIdForApi]="brandIdForApi"
      [brandDetails]="brandDetailsForSetup"
      [canUpload]="sentimentSettingsCanWrite"
      (configReady)="onGettingStartedConfigReady()"
      (message)="showSnackbar($event.text, $event.kind)"
    />
  </ng-container>

  <ng-container *ngIf="!loading && brandIdForApi && configGate === 'ready'">
    <!-- Tabs + settings (gear opens side panel when permitted) -->
    <div class="sentiment-analysis__tabs-row">
      <div class="sentiment-analysis__tabs">
        <nav class="sentiment-analysis__tab-list">
          <button
            *ngIf="isSentimentTabShown('overview')"
            type="button"
            class="sentiment-analysis__tab"
            [class.sentiment-analysis__tab--active]="activeTab === config.tabs.overview.key"
            (click)="setActiveTab(config.tabs.overview.key)"
          >
            {{ config.tabs.overview.label }}
          </button>
          <button
            *ngIf="isSentimentTabShown('details')"
            type="button"
            class="sentiment-analysis__tab"
            [class.sentiment-analysis__tab--active]="activeTab === config.tabs.details.key"
            (click)="setActiveTab(config.tabs.details.key)"
          >
            {{ config.tabs.details.label }}
          </button>
          <button
            *ngIf="isSentimentTabShown('summary')"
            type="button"
            class="sentiment-analysis__tab"
            [class.sentiment-analysis__tab--active]="activeTab === config.tabs.summary.key"
            (click)="setActiveTab(config.tabs.summary.key)"
          >
            {{ config.tabs.summary.label }}
          </button>
        </nav>
      </div>
      <button
        *ngIf="sentimentSettingsPanelAllowed"
        type="button"
        class="sentiment-analysis__settings-btn"
        title="Sentiment analysis settings"
        aria-label="Sentiment analysis settings"
        (click)="openSentimentSettingsPanel()"
      >
        <i class="fa fa-cog" aria-hidden="true"></i>
      </button>
    </div>

    <!-- Overview tab -->
    <div class="sentiment-analysis__content" [class.sentiment-analysis__content--hidden]="activeTab !== config.tabs.overview.key">
      <app-sentiment-analysis-overview-home
        [stats]="stats"
        [actionableComments]="getActionableComments()"
        [sentimentData]="getActionableMentionsSentimentData()"
        [npsScore]="getActionableMentionsNpsScore()"
        [sentimentScore]="getActionableMentionsSentimentScore()"
        [ratingOverview]="stats?.ratingOverview ?? null"
        [sentimentFilter]="themeDistributionSentimentFilter"
        (sentimentFilterChange)="themeDistributionSentimentFilter = $event; markForCheckFromTemplate()"
        [viewMode]="themeDistributionViewMode"
        (viewModeChange)="themeDistributionViewMode = $event; markForCheckFromTemplate()"
      ></app-sentiment-analysis-overview-home>
    </div>

    <!-- Details tab -->
    <div class="sentiment-analysis__content" [class.sentiment-analysis__content--hidden]="activeTab !== config.tabs.details.key">
      <app-sentiment-analysis-details-home [host]="this"></app-sentiment-analysis-details-home>
    </div>

    <!-- Summary tab (kept in DOM when inactive so generator state persists) -->
    <div class="sentiment-analysis__content" [class.sentiment-analysis__content--hidden]="activeTab !== config.tabs.summary.key">
      <app-sentiment-analysis-summary-home
        [config]="config"
        [themes]="cachedSummaryThemes"
        [onlyActionable]="summaryOnlyActionable"
        (onlyActionableChange)="summaryOnlyActionable = $event; markForCheckFromTemplate()"
        [selectedSentiment]="summarySelectedSentiment"
        (selectedSentimentChange)="onSummarySentimentChange($event)"
        [sentimentOptions]="summaryGeneratorSentimentOptions"
        [selectedThemeId]="summarySelectedThemeId"
        (selectedThemeIdChange)="onSummaryThemeIdChange($event)"
        [summaryText]="summaryText"
        [summaryTopIssues]="summaryTopIssues"
        [summaryNextSteps]="summaryNextSteps"
        [summaryStats]="summaryStats"
        [generating]="summaryGenerating"
        [loadingSummary]="summaryLoading"
        (generate)="generateSummary()"
      ></app-sentiment-analysis-summary-home>
    </div>
  </ng-container>

  <div *ngIf="!loading && !brandIdForApi" class="sentiment-analysis__empty">
    <p>Select a project to view sentiment analysis.</p>
  </div>

  <!-- Theme break-up side panel -->
  <div class="sentiment-analysis__theme-panel" *ngIf="themeBreakupPanelOpen && themeBreakupPanelTheme">
    <div class="sentiment-analysis__theme-panel-overlay" (click)="closeThemeBreakupPanel()"></div>
    <div class="sentiment-analysis__theme-panel-container">
      <div class="sentiment-analysis__theme-panel-header">
        <h3 class="sentiment-analysis__theme-panel-title">{{ themeBreakupPanelTheme.themeName }}</h3>
        <button type="button" class="sentiment-analysis__theme-panel-close" (click)="closeThemeBreakupPanel()" aria-label="Close">×</button>
      </div>
      <div class="sentiment-analysis__theme-panel-content">
        <div class="sentiment-analysis__theme-panel-section">
          <h4 class="sentiment-analysis__theme-panel-section-title">Theme performance</h4>
          <div class="sentiment-analysis__theme-panel-bar">
            <span class="sentiment-analysis__theme-panel-seg sentiment-analysis__theme-panel-seg--positive" [style.width.%]="themeBreakupPanelTheme.positive"></span>
            <span class="sentiment-analysis__theme-panel-seg sentiment-analysis__theme-panel-seg--neutral" [style.width.%]="themeBreakupPanelTheme.neutral"></span>
            <span class="sentiment-analysis__theme-panel-seg sentiment-analysis__theme-panel-seg--negative" [style.width.%]="themeBreakupPanelTheme.negative"></span>
          </div>
          <p class="sentiment-analysis__theme-panel-counts">
            +{{ themeBreakupPanelTheme.positiveCount | number }} /
            {{ themeBreakupPanelTheme.neutralCount | number }} /
            -{{ themeBreakupPanelTheme.negativeCount | number }}
            <span class="sentiment-analysis__theme-panel-mentions">{{ getTotalMentionsForTheme(themeBreakupPanelTheme) | number }} mentions</span>
          </p>
        </div>
        <div
          class="sentiment-analysis__theme-panel-section sentiment-analysis__theme-panel-section--subthemes-scroll"
          *ngIf="themeBreakupPanelSubThemes.length"
        >
          <div class="sentiment-analysis__theme-panel-subthemes-header">
            <h4 class="sentiment-analysis__theme-panel-section-title sentiment-analysis__theme-panel-section-title--subthemes-row">Sub-themes</h4>
            <div
              *ngIf="themePanelHasSuggestedSubthemes"
              class="sentiment-analysis__theme-panel-suggested-wrap"
              title="Show standard or suggested sub-themes"
            >
              <span class="sentiment-analysis__theme-panel-suggested-label">Suggested</span>
              <button
                type="button"
                class="sentiment-analysis__theme-panel-switch"
                [class.sentiment-analysis__theme-panel-switch--on]="themePanelShowSuggestedSubthemesOnly"
                role="switch"
                [attr.aria-checked]="themePanelShowSuggestedSubthemesOnly"
                (click)="toggleThemePanelSubthemesSuggested()"
              >
                <span class="sentiment-analysis__theme-panel-switch-knob"></span>
              </button>
            </div>
          </div>
          <ul class="sentiment-analysis__theme-panel-list" *ngIf="themeBreakupPanelSubThemesForDisplay.length; else themePanelSubthemesEmpty">
            <li *ngFor="let s of themeBreakupPanelSubThemesForDisplay; trackBy: trackBySubThemeId" class="sentiment-analysis__theme-panel-list-item">
              <span class="sentiment-analysis__theme-panel-list-label">{{ s.subThemeName }}</span>
              <span class="sentiment-analysis__theme-panel-list-counts">
                +{{ s.sentiment.positive.count | number }} /
                {{ s.sentiment.neutral.count | number }} /
                -{{ s.sentiment.negative.count | number }}
              </span>
              <button type="button" class="sentiment-analysis__theme-panel-list-info" title="View sub-theme details" aria-label="View sub-theme details" (click)="openSubThemeBreakupPanelFromThemePanel(s); $event.stopPropagation()">i</button>
            </li>
          </ul>
          <ng-template #themePanelSubthemesEmpty>
            <p class="sentiment-analysis__theme-panel-subthemes-empty">No sub-themes in this view</p>
          </ng-template>
        </div>
        <div class="sentiment-analysis__theme-panel-section sentiment-analysis__theme-panel-section--feedback">
          <h4 class="sentiment-analysis__theme-panel-section-title">
            Customer Feedback
            <ng-container *ngIf="config.useInsightsEngine && themePanelFeedbackTotalCount != null; else themeFeedCountSimple">
              ({{ themePanelFeedback.length }} of {{ themePanelFeedbackTotalCount }} responses)
            </ng-container>
            <ng-template #themeFeedCountSimple>({{ themePanelFeedback.length }} total responses)</ng-template>
          </h4>
          <div class="sentiment-analysis__theme-panel-feedback-body">
            <div *ngIf="themePanelFeedbackLoading" class="sentiment-analysis__theme-panel-feedback-loading">
              <span class="sentiment-analysis__theme-panel-spinner" aria-hidden="true"></span>
            </div>
            <div *ngIf="!themePanelFeedbackLoading && themePanelFeedback.length === 0" class="sentiment-analysis__theme-panel-feedback-empty">
              <p>No feedback available for this theme</p>
            </div>
            <div
              *ngIf="!themePanelFeedbackLoading && themePanelFeedback.length"
              class="sentiment-analysis__theme-panel-feedback-list"
              (scroll)="onThemePanelFeedbackScroll($event)"
            >
            <article
              *ngFor="let feedback of themePanelFeedback; trackBy: trackByPanelFeedbackIndex"
              class="sentiment-analysis__theme-panel-feedback-card"
            >
              <div class="sentiment-analysis__theme-panel-feedback-meta">
                <span class="sentiment-analysis__theme-panel-feedback-sentiment" [class.sentiment-analysis__theme-panel-feedback-sentiment--positive]="feedback.sentiment === 'positive'" [class.sentiment-analysis__theme-panel-feedback-sentiment--neutral]="feedback.sentiment === 'neutral'" [class.sentiment-analysis__theme-panel-feedback-sentiment--negative]="feedback.sentiment === 'negative'">{{ (feedback.sentiment || 'unknown') | uppercase }}</span>
                <button
                  *ngIf="showSentimentFeedLinkRedirect && feedback.feed_id"
                  type="button"
                  class="sentiment-analysis__theme-panel-feedback-open"
                  (click)="showFeedDetails(feedback.feed_id); $event.stopPropagation()"
                  aria-label="Open feedback details"
                >
                  <img class="sentiment-analysis__theme-panel-feedback-open-icon sentiment-analysis__theme-panel-feedback-open-icon--default" src="assets/images/launch.svg" alt="" />
                  <img class="sentiment-analysis__theme-panel-feedback-open-icon sentiment-analysis__theme-panel-feedback-open-icon--active" src="assets/images/blue-link-icon.svg" alt="" />
                </button>
              </div>
              <p class="sentiment-analysis__theme-panel-feedback-comment">"{{ feedback.feedback?.primaryComment || 'No comment available' }}"</p>
              <div
                *ngIf="showSentimentCohortFooter && feedback.cohortTagsFooter?.length"
                class="sentiment-analysis__theme-panel-feedback-footer"
                aria-label="Cohort"
              >
                <span
                  *ngFor="let tag of feedback.cohortTagsFooter"
                  class="sentiment-analysis__theme-panel-feedback-footer-chip"
                >
                  <span class="sentiment-analysis__theme-panel-feedback-footer-key">{{ tag.label }}</span>
                  <span class="sentiment-analysis__theme-panel-feedback-footer-value">{{ tag.value }}</span>
                </span>
              </div>
            </article>
            <div *ngIf="themePanelFeedbackLoadingMore" class="sentiment-analysis__theme-panel-feedback-loading sentiment-analysis__theme-panel-feedback-loading--inline">
              <span class="sentiment-analysis__theme-panel-spinner" aria-hidden="true"></span>
              <span>Loading more…</span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sub-theme break-up side panel (higher z-index when open so it stacks above Theme panel) -->
  <div class="sentiment-analysis__theme-panel sentiment-analysis__theme-panel--nested" *ngIf="subThemeBreakupPanelOpen && subThemeBreakupPanelSubTheme">
    <div class="sentiment-analysis__theme-panel-overlay" (click)="closeSubThemeBreakupPanel()"></div>
    <div class="sentiment-analysis__theme-panel-container">
      <div class="sentiment-analysis__theme-panel-header">
        <h3 class="sentiment-analysis__theme-panel-title">{{ subThemeBreakupPanelSubTheme.subThemeName }}</h3>
        <button type="button" class="sentiment-analysis__theme-panel-close" (click)="closeSubThemeBreakupPanel()" aria-label="Close">×</button>
      </div>
      <div class="sentiment-analysis__theme-panel-content">
        <div class="sentiment-analysis__theme-panel-section">
          <h4 class="sentiment-analysis__theme-panel-section-title">Sub-theme performance</h4>
          <div class="sentiment-analysis__theme-panel-bar">
            <span class="sentiment-analysis__theme-panel-seg sentiment-analysis__theme-panel-seg--positive" [style.width.%]="subThemeBreakupPanelSubTheme.positive"></span>
            <span class="sentiment-analysis__theme-panel-seg sentiment-analysis__theme-panel-seg--neutral" [style.width.%]="subThemeBreakupPanelSubTheme.neutral"></span>
            <span class="sentiment-analysis__theme-panel-seg sentiment-analysis__theme-panel-seg--negative" [style.width.%]="subThemeBreakupPanelSubTheme.negative"></span>
          </div>
          <p class="sentiment-analysis__theme-panel-counts">
            +{{ subThemeBreakupPanelSubTheme.positiveCount | number }} /
            {{ subThemeBreakupPanelSubTheme.neutralCount | number }} /
            -{{ subThemeBreakupPanelSubTheme.negativeCount | number }}
            <span class="sentiment-analysis__theme-panel-mentions">{{ getTotalMentionsForSubTheme(subThemeBreakupPanelSubTheme) | number }} mentions</span>
          </p>
        </div>
        <div class="sentiment-analysis__theme-panel-section sentiment-analysis__theme-panel-section--feedback">
          <h4 class="sentiment-analysis__theme-panel-section-title">
            Customer Feedback
            <ng-container *ngIf="config.useInsightsEngine && subThemePanelFeedbackTotalCount != null; else subThemeFeedCountSimple">
              ({{ subThemePanelFeedback.length }} of {{ subThemePanelFeedbackTotalCount }} responses)
            </ng-container>
            <ng-template #subThemeFeedCountSimple>({{ subThemePanelFeedback.length }} total responses)</ng-template>
          </h4>
          <div class="sentiment-analysis__theme-panel-feedback-body">
            <div *ngIf="subThemePanelFeedbackLoading" class="sentiment-analysis__theme-panel-feedback-loading">
              <span class="sentiment-analysis__theme-panel-spinner" aria-hidden="true"></span>
            </div>
            <div *ngIf="!subThemePanelFeedbackLoading && subThemePanelFeedback.length === 0" class="sentiment-analysis__theme-panel-feedback-empty">
              <p>No feedback available for this sub-theme</p>
            </div>
            <div
              *ngIf="!subThemePanelFeedbackLoading && subThemePanelFeedback.length"
              class="sentiment-analysis__theme-panel-feedback-list"
              (scroll)="onSubThemePanelFeedbackScroll($event)"
            >
            <article
              *ngFor="let feedback of subThemePanelFeedback; trackBy: trackByPanelFeedbackIndex"
              class="sentiment-analysis__theme-panel-feedback-card"
            >
              <div class="sentiment-analysis__theme-panel-feedback-meta">
                <span class="sentiment-analysis__theme-panel-feedback-sentiment" [class.sentiment-analysis__theme-panel-feedback-sentiment--positive]="feedback.sentiment === 'positive'" [class.sentiment-analysis__theme-panel-feedback-sentiment--neutral]="feedback.sentiment === 'neutral'" [class.sentiment-analysis__theme-panel-feedback-sentiment--negative]="feedback.sentiment === 'negative'">{{ (feedback.sentiment || 'unknown') | uppercase }}</span>
                <button
                  *ngIf="showSentimentFeedLinkRedirect && feedback.feed_id"
                  type="button"
                  class="sentiment-analysis__theme-panel-feedback-open"
                  (click)="showFeedDetails(feedback.feed_id); $event.stopPropagation()"
                  aria-label="Open feedback details"
                >
                  <img class="sentiment-analysis__theme-panel-feedback-open-icon sentiment-analysis__theme-panel-feedback-open-icon--default" src="assets/images/launch.svg" alt="" />
                  <img class="sentiment-analysis__theme-panel-feedback-open-icon sentiment-analysis__theme-panel-feedback-open-icon--active" src="assets/images/blue-link-icon.svg" alt="" />
                </button>
              </div>
              <p class="sentiment-analysis__theme-panel-feedback-comment">"{{ feedback.feedback?.primaryComment || 'No comment available' }}"</p>
              <div
                *ngIf="showSentimentCohortFooter && feedback.cohortTagsFooter?.length"
                class="sentiment-analysis__theme-panel-feedback-footer"
                aria-label="Cohort"
              >
                <span
                  *ngFor="let tag of feedback.cohortTagsFooter"
                  class="sentiment-analysis__theme-panel-feedback-footer-chip"
                >
                  <span class="sentiment-analysis__theme-panel-feedback-footer-key">{{ tag.label }}</span>
                  <span class="sentiment-analysis__theme-panel-feedback-footer-value">{{ tag.value }}</span>
                </span>
              </div>
            </article>
            <div *ngIf="subThemePanelFeedbackLoadingMore" class="sentiment-analysis__theme-panel-feedback-loading sentiment-analysis__theme-panel-feedback-loading--inline">
              <span class="sentiment-analysis__theme-panel-spinner" aria-hidden="true"></span>
              <span>Loading more…</span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-feed-detail-panel ></app-feed-detail-panel>
